// extracted by mini-css-extract-plugin
export var active = "PageButtons-module--active--38629";
export var container = "PageButtons-module--container--f2a63";
export var inner = "PageButtons-module--inner--81c15";
export var link = "PageButtons-module--link--0b431";
export var num = "PageButtons-module--num--8322f";
export var numbers = "PageButtons-module--numbers--86b58";